/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for next icon.
 *
 * @author Hari Gangadharan
 */
const Next = props => (
  <SvgIcon viewBox="1209 28 18 9" {...props}>
    <path
      d="M1211.56028,31.7501875 L1214.03008,29.2804375 C1214.32334,28.9871875 1214.32334,
      28.5131875 1214.03008,28.2199375 C1213.73682,27.9266875 1213.26281,27.9266875 1212.96956,
      28.2199375 L1209.22023,31.9691875 C1209.18498,32.0044375 1209.15348,32.0434375 1209.12573,
      32.0846875 C1209.11373,32.1019375 1209.10623,32.1214375 1209.09573,32.1401875 C1209.08223,
      32.1641875 1209.06798,32.1874375 1209.05673,32.2136875 C1209.04698,32.2376875 1209.04098,
      32.2631875 1209.03348,32.2879375 C1209.02748,32.3104375 1209.01923,32.3306875 1209.01473,
      32.3531875 C1208.99522,32.4499375 1208.99522,32.5496875 1209.01473,32.6471875 C1209.01923,
      32.6696875 1209.02748,32.6899375 1209.03348,32.7116875 C1209.04098,32.7371875 1209.04698,
      32.7626875 1209.05673,32.7866875 C1209.06798,32.8129375 1209.08223,32.8361875 1209.09573,
      32.8601875 C1209.10623,32.8789375 1209.11373,32.8984375 1209.12573,32.9156875 C1209.15348,
      32.9569375 1209.18498,32.9959375 1209.22023,33.0311875 L1212.96956,36.7804375 C1213.11581,
      36.9266875 1213.30781,37.0001875 1213.49982,37.0001875 C1213.69182,37.0001875 1213.88383,
      36.9266875 1214.03008,36.7804375 C1214.32334,36.4871875 1214.32334,36.0131875 1214.03008,
      35.7199375 L1211.56028,33.2501875 L1226.25008,33.2501875 C1226.66409,33.2501875 1227.0001,
      32.9141875 1227.0001,32.5001875 C1227.0001,32.0861875 1226.66409,31.7501875 1226.25008,
      31.7501875 L1211.56028,31.7501875 Z"
      transform="translate(1218.000100, 32.500094) rotate(180.000000) translate(-1218.000100, -32.500094)"
    />
  </SvgIcon>
);

export default Next;



// WEBPACK FOOTER //
// ./src/js/icons/Next.jsx